import { Nodo } from "../utils/nodo";
import { AtributosService } from "../../_services/_index";
import { ValorAtributo } from "./valor-atributo";
import { Unidad } from "./unidad";
import { AtributoSegmento } from "./atributo-segmento";
import { Traducible } from "./traducible";
import { ReglaAtributo } from "./regla-atributo";
import { truncate } from "fs";

export class Atributo extends Nodo {
    idCliente: number;
    idAtributo: number;
    idPadre: number;
    hijos: Atributo[] = [];
    tipo: number;
    nombreDes: Traducible;
    profundidad: number;
    unidad: Unidad;
    activo: boolean;
    decimales: number;
    comparable: boolean;
    nombreDesInfo: Traducible;
    valoresAtributo: Array<ValorAtributo> = new Array<ValorAtributo>();
    idRaiz: number;
    asignableVerParc: number;
    atributosSegmentos: AtributoSegmento[] = [];
    orden: number;
    codigo: string;
    importancia: string ;

    expandido: boolean = true; // se usa en para determinar si esxta expandido o no en la tablaAtributosABMVersion |B|

    constructor(params = undefined) {
        super(params);
        if (params != undefined) {
            this.idCliente = params.idCliente;
            this.idNodo = params.idAtributo;
            this.idAtributo = params.idAtributo;
            this.idPadre = params.idPadre;
            this.tipo = params.tipo;
            this.nombreDes = params.nombreDes;
            this.profundidad = params.profundidad;
            this.unidad = params.unidad;
            this.activo = params.activo;
            this.decimales = params.decimales;
            this.comparable = params.comparable;
            this.nombreDesInfo = params.nombreDesInfo;
            this.instanceValoresAtributos(params.valoresAtributo);
            this.idRaiz = params.idRaiz;
            this.asignableVerParc = params.asignableVerParc;
            this.atributosSegmentos = params.atributosSegmentos;
            this.orden = params.orden;
            this.codigo = params.codigo;
            this.expandido = params.expandido;
            this.importancia = params.importancia;
        }
        else {
            this.idCliente = undefined;
            this.idNodo = undefined;
            this.idAtributo = undefined;
            this.idPadre = undefined;
            this.tipo = undefined;
            this.profundidad = undefined;
            this.unidad = new Unidad();
            this.activo = true;
            this.decimales = undefined;
            this.comparable = true;
            this.idRaiz = undefined;
            this.asignableVerParc = 0;
            this.atributosSegmentos = [];
            this.orden = undefined;
            this.codigo = undefined;
            this.nombreDes = new Traducible();
            this.nombreDesInfo = new Traducible();
            this.importancia = undefined;
        }
    }

    public instanceValoresAtributos(elements: Array<any>){
        if (elements != undefined) {
            elements.forEach(element => {
                this.valoresAtributo.push( new ValorAtributo(element) );
            });
        }        
    }

    public getHijos(atributoService: AtributosService, excluir: number[] = [], inclValores:boolean = false): void {
        if (this.hijos.length == 0) {
            var auxNodo: Atributo = new Atributo(undefined);
            auxNodo.idCliente = this.idCliente;
            auxNodo.idAtributo = this.idAtributo;
            auxNodo.idPadre = this.idPadre;
            auxNodo.hijos = this.hijos;
            auxNodo.tipo = this.tipo;
            auxNodo.nombreDes = this.nombreDes;
            auxNodo.profundidad = this.profundidad;
            auxNodo.unidad = this.unidad;
            auxNodo.activo = this.activo;
            auxNodo.decimales = this.decimales;
            auxNodo.comparable = this.comparable;
            auxNodo.nombreDesInfo = this.nombreDesInfo;
            auxNodo.valoresAtributo = this.valoresAtributo;
            auxNodo.idRaiz = this.idRaiz;
            auxNodo.asignableVerParc = this.asignableVerParc;
            auxNodo.atributosSegmentos = this.atributosSegmentos;
            auxNodo.orden = this.orden;
            auxNodo.codigo = this.codigo;
            auxNodo.importancia = this.importancia;

            atributoService.getHijos(auxNodo, excluir,inclValores)
                .subscribe(res => {
                    if (res.Succeed) {
                        res.Data.forEach(element => {
                            this.hijos.push(
                                new Atributo(element)
                            );
                        });
                    }
                }, null, null);

        }
    }
}